import {
  Button as MUIButton,
  ButtonProps as MuiButtonProps,
  CircularProgress,
} from "@mui/material";

export interface ButtonProps extends MuiButtonProps {
  /**
   * If true, displays a loading spinner at the end of the button.
   * The loading spinner replaces the endIcon when active.
   * @default false
   */
  loading?: boolean;
}

/**
 * A customized button component built on top of Material-UI Button.
 *
 * Features:
 * - Supports all Material-UI Button variants (text, contained, outlined)
 * - Supports all Material-UI Button sizes (small, medium, large)
 * - Includes a loading state with a circular progress indicator
 * - Removes elevation and text transformation by default for a cleaner look
 *
 * @example
 * ```tsx
 * // Basic usage
 * <Button variant="contained">Click me</Button>
 *
 * // With loading state
 * <Button loading={true} variant="outlined">Loading...</Button>
 *
 * // With custom size
 * <Button size="large" variant="text">Large Button</Button>
 * ```
 */
export function Button(props: ButtonProps) {
  return (
    <MUIButton
      disableElevation
      endIcon={
        props.loading ? <CircularProgress size={"1rem"} /> : props.endIcon
      }
      {...props}
      sx={{ ...props.sx, textTransform: "none" }}
    >
      {props.children}
    </MUIButton>
  );
}
